/**
 * Bundled fallback for variety sheets when the API returns no products.
 * Primary data: `GET /api/site` → `seedVarieties.families` (managed in admin; stored key unchanged).
 */

export const FALLBACK_SEED_VARIETY_PRODUCTS = [
  {
    id: 'tomato',
    categoryId: 'tomato',
    familyLabel: '',
    categoryName: 'Tomato',
    summary: 'Hybrid tomato lines with published agronomic specifications.',
    variants: [
      {
        id: 'mintoo-super-f1',
        name: 'Mintoo Super F1',
        breeder: 'LTSL',
        image: '/seed-varieties/tomato-mintoo-super-f1.png',
        alt: 'Ripe red tomatoes stacked on wood',
        specs: [
          { label: 'Color', value: 'Attractive RED' },
          { label: 'Weight (kg)', value: '100 gm' },
          { label: 'Rate/Dec. (g)', value: '1 gm' },
          { label: 'Sowing Time', value: 'Sec–Dec' },
          { label: 'Yield/Acre (MT)', value: '8–10' },
          { label: 'Maturity (Days)', value: '70–80' },
        ],
      },
      {
        id: 'ruby-king-f1',
        name: 'Ruby King F1',
        breeder: 'LTSL',
        image:
          'https://images.unsplash.com/photo-1592841200221-a6892f4c594f?auto=format&fit=crop&w=900&q=80',
        alt: 'Tomatoes on the vine',
        specs: [
          { label: 'Color', value: 'Deep Red' },
          { label: 'Weight (kg):', value: '90-110 gm' },
          { label: 'Rate/Dec. (g):', value: '1.2 gm' },
          { label: 'Sowing time', value: 'Jul-Nov' },
          { label: 'Yield/Acre (MT)', value: '38-48' },
          { label: 'Maturity (Days)', value: '60-65' },
        ],
      },
    ],
  },
];

/** Prefer CMS data when at least one product exists; otherwise bundled demo. */
export function mergeSeedVarietyProductsFromSite(site) {
  const list = site?.seedVarieties?.families;
  if (Array.isArray(list) && list.length > 0) return list;
  return FALLBACK_SEED_VARIETY_PRODUCTS;
}

/** Index card / list title: optional product line label (`familyLabel`), else category name. */
export function seedVarietyProductDisplayTitle(product) {
  if (!product) return '';
  const label = typeof product.familyLabel === 'string' ? product.familyLabel.trim() : '';
  if (label) return label;
  return typeof product.categoryName === 'string' ? product.categoryName.trim() : '';
}

export function getSeedVarietyProductInList(products, productId) {
  if (!productId || !Array.isArray(products)) return null;
  return products.find((p) => p.id === productId) || null;
}

export function getSeedVarietyVariantInList(products, productId, variantId) {
  const product = getSeedVarietyProductInList(products, productId);
  if (!product || !variantId) return null;
  const variant = product.variants.find((v) => v.id === variantId);
  if (!variant) return null;
  return { product, variant };
}
